import { apiB2B } from '../axios-client';
import { B2B_MANAGE_USERS_PATH } from '../../constants/links';
export const sortByMap = {
    Name: 'firstName',
    Email: 'email',
    Phone: 'phone',
    Role: 'role',
    Status: 'status',
    'Date Added': 'addedDate',
};
export const SEARCH_BY = {
    name: 'Name',
    status: 'Status',
    role: 'Role',
};
export const MANAGE_USERS_PAGE_SIZE = 21;
export const defaultFilterConfig = {
    type: 'default',
    value: 'default',
};
export const usersApi = {
    getUsers: (sortConfig, filterConfig) => apiB2B.post(B2B_MANAGE_USERS_PATH, {
        UserSearch: filterConfig || defaultFilterConfig,
    }, {
        params: {
            ps: MANAGE_USERS_PAGE_SIZE,
            pn: (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.page) || 1,
            sb: (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.sortBy) || 'addedDate',
            asc: (sortConfig === null || sortConfig === void 0 ? void 0 : sortConfig.ascendingOrder) || false,
        },
    }),
};
